import { Controller } from "@hotwired/stimulus"

// Polls the conversion's progress JSON and copies the server's words onto
// the page. The server decides what to say (stage, sales counted, minutes
// to expect); this controller only keeps the page current, so a customer
// who arrived while the PDF was still being read sees the estimate the
// moment the planner has one, and the totals check when it starts.
export default class extends Controller {
  static targets = ["bar", "text", "heading", "lead", "emailTitle"]
  static values = {
    url: String,
    intervalMs: { type: Number, default: 2000 }
  }

  connect() {
    this.poll()
    this.timer = setInterval(() => this.poll(), this.intervalMsValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  async poll() {
    try {
      const res = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
      if (!res.ok) return
      const data = await res.json()

      if (this.hasBarTarget) {
        this.barTarget.style.width = `${data.percentage}%`
      }
      this.apply(data.copy)

      if (data.status === "completed" || data.status === "failed" || data.status === "awaiting_unlock") {
        clearInterval(this.timer)
        window.location.reload()
      }
    } catch (_) {
      // ignore transient network errors; next tick will retry
    }
  }

  apply(copy) {
    if (!copy) return
    this.set("heading", copy.heading)
    this.set("lead", copy.lead)
    this.set("text", copy.text)
    this.set("emailTitle", copy.email_title)
  }

  set(name, value) {
    const target = this[`${name}Target`]
    const has = this[`has${name.charAt(0).toUpperCase()}${name.slice(1)}Target`]
    if (has && typeof value === "string" && target.textContent !== value) target.textContent = value
  }
}
